import { shallowEqual, useSelector } from "react-redux"

import type { IRootState } from "@/3514/store"

import { COACH_DASHBOARD_REDUCER_NAME, type ICoachDashboardState } from "./coach.dashboard.store.slice"

type _TSelector = (state: IRootState) => ICoachDashboardState

function _selector(): _TSelector {
    return (state: IRootState): ICoachDashboardState | undefined => state[COACH_DASHBOARD_REDUCER_NAME]
}

function useCoachDashboardSelector(): ICoachDashboardState {
    return useSelector(_selector(), shallowEqual)
}

export default useCoachDashboardSelector
